// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TaskAssignedUsersEditScreen from "../../src/screens/task-assigned-users/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TaskAssignedUserNewRouteProps */

/** @typedef {Record<string, never>} TaskAssignedUserNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TaskAssignedUserNewRouteProps, TaskAssignedUserNewRouteState>}
 */
class TaskAssignedUserNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Assign user")}</ScreenTitle>
        <TaskAssignedUsersEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TaskAssignedUserNewRouteProps>} */
const TaskAssignedUserNewRouteComponent = memo(shapeComponent(TaskAssignedUserNewRoute))

export default TaskAssignedUserNewRouteComponent
